module.exports = __webpack_public_path__ + "assets/vegan-641f0c.svg";